import { render } from "./ClickableFields.vue?vue&type=template&id=623b18e0&scoped=true"
import script from "./ClickableFields.vue?vue&type=script&lang=js"
export * from "./ClickableFields.vue?vue&type=script&lang=js"

import "./ClickableFields.vue?vue&type=style&index=0&id=623b18e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623b18e0"]])

export default __exports__